import React, { useState } from "react";
import PropTypes from "prop-types";
import { Dialog, DialogTitle, DialogContent, DialogActions, IconButton } from "@mui/material";
import MDButton from "../MDButton";
import CloseIcon from "@mui/icons-material/Close";

const LogoDialog = ({ open, onClose, onUpload, existingLogoUrl }) => {
  const [selectedLogoFile, setSelectedLogoFile] = useState(null);
  const [logoPreview, setLogoPreview] = useState(null);
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setSelectedLogoFile(file);
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setLogoPreview(reader.result);
      };
      reader.readAsDataURL(file);
    } else {
      setLogoPreview(null);
    }
  };

  const handleCancel = () => {
    setSelectedLogoFile(null);
    setLogoPreview(null);
    onClose();
  };

  const handleUpload = () => {
    if (selectedLogoFile) {
      onUpload(selectedLogoFile); // Only this is needed
      handleCancel();
    }
  };

  return (
    <Dialog open={open} onClose={handleCancel}>
      <DialogTitle>
        Upload College Logo
        <IconButton
          onClick={handleCancel}
          sx={{
            position: "absolute",
            top: 8,
            right: 8,
            color: "#ff4444",
            "&:hover": {
              transform: "scale(1.2)",
              color: "#d32f2f",
              backgroundColor: "rgba(255,255,255,0.2)",
            },
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <input type="file" accept="image/*" onChange={handleFileChange} />
        {(logoPreview || existingLogoUrl) && (
          <div style={{ marginTop: "10px", textAlign: "center" }}>
            <img
              src={logoPreview || `${API_BASE_URL}/${existingLogoUrl}`}
              alt="Preview"
              style={{
                maxWidth: "200px",
                maxHeight: "150px",
                borderRadius: "8px",
                border: "1px solid #ccc",
              }}
            />
          </div>
        )}
      </DialogContent>
      <DialogActions>
        <MDButton onClick={handleCancel} color="error">
          Cancel
        </MDButton>
        <MDButton onClick={handleUpload} color="info">
          Upload
        </MDButton>
      </DialogActions>
    </Dialog>
  );
};

LogoDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onUpload: PropTypes.func.isRequired,
  existingLogoUrl: PropTypes.string,
};

export default LogoDialog;
